"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _wrapNativeSuper = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Common base class for errors resulting from data parsing and validation
 * @author Stepan Mik
 */

var DataDictionaryError =
/*#__PURE__*/
function (_Error) {
  _inherits(DataDictionaryError, _Error);

  function DataDictionaryError(message, cause) {
    var _this;

    _classCallCheck(this, DataDictionaryError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DataDictionaryError).call(this, message));
    _this.cause = cause;
    return _this;
  }

  return DataDictionaryError;
}(_wrapNativeSuper(Error));

exports.DataDictionaryError = DataDictionaryError;